<template>
    <div class="clickable-list-item" title="clickable-list-item" @click="handleClick">
        <g-media-object vertical-align="center" class="g-p-5">
            <template #left>
                <div v-if="image || icon" class="thumbnail-container">
                    <img v-if="image" :src="image" alt="file" class="image" />
                    <g-icon v-else :name="icon" color="grey-5" />
                </div>
            </template>

            <template #default>
                <slot name="middle" />
            </template>

            <template #right>
                <slot name="right" />
                <g-icon name="chevron-right" color="grey-6" ckass="g-pl-5 g-mt-2" />
            </template>
        </g-media-object>

        <g-divider v-if="!isLast" margin="none" />
    </div>
</template>

<script>
    export default {
        name: 'ClickableListItem',
        props: {
            image: {
                type: String,
                default: null
            },
            icon: {
                type: String,
                default: null
            },
            isLast: {
                type: Boolean,
                default: false
            }
        },

        setup(props, { emit }) {
            const handleClick = () => {
                emit('click');
            };

            return {
                handleClick
            };
        }
    };
</script>

<style lang="scss" scoped>
    .clickable-list-item {
        &:hover {
            background-color: $g-color-grey-2;
        }
        :hover {
            cursor: pointer;
        }

        ::v-deep .media-object-left {
            margin-right: $g-spacing-5;
        }

        .thumbnail-container {
            width: 57px;
            height: 57px;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: $g-color-grey-3;
            border-radius: $g-border-radius-md;
        }

        .image {
            width: 57px;
            height: 57px;
            object-fit: cover;
            border-radius: $g-border-radius-md;
        }
    }
</style>
